import _ from "lodash";
import { EVENT_TYPES, ON_DEMAND, SCHEDULED } from "../constants";

const filterSport = (events, value) =>
  events.filter((e) => e.eventTypeId === value);

const filterCategory = (events, value) =>
  events.filter((e) => e.categoryId === value);

const filterByConference = (events, conferenceId) =>
  events.filter(
    (event) =>
      event.parentClientId === conferenceId ||
      event.team1ClientId === conferenceId ||
      event.team2ClientId === conferenceId ||
      event.clientId === conferenceId
  );

const filterBySchool = (events, clientId) =>
  events.filter(
    (event) =>
      event.team1ClientId === clientId ||
      event.team2ClientId === clientId ||
      event.clientId === clientId
  );

const searchInTitle = (events, value) =>
  events.filter(
    (e) => e.title && e.title.toLowerCase().indexOf(value.toLowerCase()) > -1
  );

const filterByEventType = (events, eventType) => {
  switch (eventType) {
    case 0:
      return events;
    case 1:
      return events.filter((event) => !event.ppv);
    case 2:
      return events.filter((event) => event.ppv);
    default:
      return events;
  }
};

const filterByDateRange = (events, startDate, endDate) => {
  const startDateTime = startDate.getTime();
  const endDateTime = endDate.getTime();
  return events.filter(
    (e) =>
      Date.parse(e.startTime) >= startDateTime &&
      Date.parse(e.startTime) <= endDateTime
  );
};

export const filterEvents = (events, filters, client, tabName) => {
  let filteredEvents = Object.assign([], events);
  if (filters.sport) {
    filteredEvents = filterSport(filteredEvents, filters.sport);
  }

  if (filters.category) {
    filteredEvents = filterCategory(filteredEvents, filters.category);
  }

  if (filters.conferenceId) {
    filteredEvents = filterByConference(filteredEvents, filters.conferenceId);
  }

  if (filters.clientId !== client.id) {
    filteredEvents = filterBySchool(filteredEvents, filters.clientId);
  }

  if (filters.text) {
    filteredEvents = searchInTitle(filteredEvents, filters.text);
  }

  if (tabName === SCHEDULED) {
    filteredEvents = filterByDateRange(
      filteredEvents,
      filters.sStartDate,
      filters.sEndDate
    );
    filteredEvents = _.orderBy(filteredEvents, "startTime", "asc");
  }

  if (client.features.ppv) {
    filteredEvents = filterByEventType(filteredEvents, filters.eventType);
  }

  if (tabName === ON_DEMAND) {
    filteredEvents = filterByDateRange(
      filteredEvents,
      filters.oStartDate,
      filters.oEndDate
    );
  }

  return filteredEvents;
};

export const getSportName = (sportId, types) =>
  types.find((type) => type.id === sportId).name;

export const getCategoryName = (categoryId, categories) =>
  categories.find((type) => type.id === categoryId).name;

export const getSchoolName = (schools, schoolId) => {
  const schoolsFormatted = _.orderBy(
    [
      ...schools.map((school) => ({
        value: school.id,
        text: school.clientName
      }))
    ],
    "text",
    "asc"
  );
  const school = schoolsFormatted.find((option) => option.value === schoolId);
  return school ? school.text : "";
};

export const getEventTypeName = (eventType) =>
  EVENT_TYPES.find((e) => e.value === eventType).text;

export const updateScheduledStartDate = (
  date,
  updateFiltersAction,
  filters
) => {
  if (date.getTime() >= filters.sEndDate.getTime()) {
    updateFiltersAction({ ...filters, sStartDate: date, sEndDate: date });
  } else {
    updateFiltersAction({ ...filters, sStartDate: date });
  }
};

export const updateScheduledEndDate = (date, updateFiltersAction, filters) => {
  if (date.getTime() <= filters.sStartDate.getTime()) {
    updateFiltersAction({ ...filters, sStartDate: date, sEndDate: date });
  } else {
    updateFiltersAction({ ...filters, sEndDate: date });
  }
};

export const resetScheduledDates = (updateFiltersAction, filters) => {
  updateFiltersAction({
    ...filters,
    sStartDate: new Date(new Date().setHours(0, 0, 0, 0)),
    sEndDate: new Date(new Date().setDate(new Date().getDate() + 60))
  });
};

export const updateOnDemandStartDate = (date, updateFiltersAction, filters) => {
  if (date.getTime() >= filters.oEndDate.getTime()) {
    updateFiltersAction({ ...filters, oStartDate: date, oEndDate: date });
  } else {
    updateFiltersAction({ ...filters, oStartDate: date });
  }
};

export const updateOnDemandEndDate = (date, updateFiltersAction, filters) => {
  if (date.getTime() <= filters.oStartDate.getTime()) {
    updateFiltersAction({ ...filters, oStartDate: date, oEndDate: date });
  } else {
    updateFiltersAction({ ...filters, oEndDate: date });
  }
};

export const resetOnDemandDates = (updateFiltersAction, filters) => {
  updateFiltersAction({
    ...filters,
    oStartDate: new Date(new Date().setDate(new Date().getDate() - 60)),
    oEndDate: new Date()
  });
};

export const clearSportFilter = (
  updateFiltersAction,
  filters,
  history,
  location
) => {
  const searchParams = new URLSearchParams(location?.search);
  searchParams.delete("sport");
  history.push(`${location.pathname}?${searchParams.toString()}`);
  filters.sport = 0;
  updateFiltersAction(filters);
};

export const clearEventTypeFilter = (updateFiltersAction, filters) => {
  filters.eventType = 0;
  updateFiltersAction(filters);
};

export const clearConferenceFilter = (updateFiltersAction, filters) => {
  filters.conferenceId = null;
  updateFiltersAction(filters);
};

export const clearSchoolFilter = (updateFiltersAction, filters, id) => {
  filters.clientId = id;
  updateFiltersAction(filters);
};

export const clearTextFilter = (updateFiltersAction, filters) => {
  filters.text = "";
  updateFiltersAction(filters);
};

export const clearCategoryFilter = (
  updateFiltersAction,
  filters,
  history,
  location
) => {
  const searchParams = new URLSearchParams(location?.search);
  searchParams.delete("category");
  history.push(`${location.pathname}?${searchParams.toString()}`);
  filters.category = 0;
  updateFiltersAction(filters);
};
